import React from "react";
import type { ColumnDefinition } from "@frui.ts/dataviews";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import EnforcementUsersViewModel from "../../../viewModels/enforcement/enforcementUsers/enforcementUsersViewModel";
import ListView from "../../common/list";
import EnforcementUserFilters from "./enforcementUserFilters";
import type EnforcementTabletUserResponse from "entities/enforcementTabletUserResponse";

const EnforcementUsersView: ViewComponent<EnforcementUsersViewModel> = observer(({ vm }) => {
  const columns: ColumnDefinition<EnforcementTabletUserResponse>[] = [
    {
      title: vm.translateAttribute("code"),
      property: "code",
    },
    {
      title: vm.translateAttribute("id"),
      property: "id",
    },
    {
      title: vm.translateAttribute("userType"),
      property: "userType",
      valueFormatter: props => vm.translateUserType(props.value),
    },
    {
      title: vm.translateAttribute("isManager"),
      property: "isManager",
      valueFormatter: props => (props.value ? vm.translateGeneral("boolean.true") : vm.translateGeneral("boolean.false")),
    },
  ];

  return <ListView vm={vm} columns={columns} aboveTable={<EnforcementUserFilters vm={vm} />} />;
});

registerView(EnforcementUsersView, EnforcementUsersViewModel);
